import { Sun, Moon } from "lucide-react";
import { useTheme } from "next-themes";

export default function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const dark = theme !== "light";
  return (
    <button
      data-testid="theme-toggle"
      onClick={() => setTheme(dark ? "light" : "dark")}
      title={dark ? "Mode terang" : "Mode gelap"}
      className="p-2 rounded-lg text-slate-500 dark:text-slate-300 hover:bg-slate-200 dark:hover:bg-slate-800 transition-colors"
    >
      {dark ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
    </button>
  );
}
